import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import { Row, Col, Card, CardHeader, CardBody, Form, Input, InputGroup, InputGroupText, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FaEye, FaSearch, } from 'react-icons/fa';

const Distribution = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');

    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState('');
    const [stateOpt, setStateOpt] = useState('');
    const [state, setState] = useState("0");

    useEffect(() => { get_state_list(); }, []);

    const get_state_list = () => {

        let postData = [{ "country_code": "1" }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const get_distribution_list = (e) => {
        e.preventDefault();

        setLoading(true);

        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "state_id": state, "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Activity/input_distribution_view2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        {
                            sl: index + 1,
                            location: row.wh_id,
                            date: row.distribution_date.split(" ")[0].split('-').reverse().join('-'),
                            product_name: row.prod_name,
                            total_qty: row.distribution_qty,
                            farmer_count: row.total_farmer,
                            action: <FaEye className='me-3 cursor' color="#FFC000" size={20} onClick={() => farmer_list_handler(row.farmer_detail)} />
                        }
                    )
                });

                setTableData(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });


    }

    const farmer_list_handler = (dtl) => {

        const list = dtl.map((row, index) => {
            return {
                sl: index + 1,
                farmer_code: row.farmer_code,
                farmer_name: row.f_name + " (" + row.f_name_ne + ")",
                qty: row.distribution_qty + " " + row.uom_desc
            }
        })

        setModalData(list);
        setViewModal(true);
    }

    const download_excel_handler = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id') }];
        axios({
            method: 'post',
            url: mainurl + 'Traceability/farmer_input_distribution_ex',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        {
                            sl_no: index + 1,
                            farmer_code: row.farmer_code,
                            farmer_name: row.f_name,
                            distribution_date: row.distribution_date?.split(" ")[0].split('-').reverse().join('-'),
                            quantity: row["concat(a.distribution_qty,' ', u.uom_desc)"],
                        }
                    )
                });

                if (list.length > 0) {
                    let wb = XLSX.utils.book_new(),
                        ws = XLSX.utils.json_to_sheet(list);
                    XLSX.utils.book_append_sheet(wb, ws, "Mysheet1");
                    XLSX.writeFile(wb, "distribution.xlsx");
                    let notify = notification({ message: "Excel downloaded successfully", type: 'success' });
                    notify();
                } else {
                    let notify = notification({ message: "No data found!", type: 'error' });
                    notify();
                }
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }


    return (
        <>
            <Header />
            <Page title='Input Distribution' breadcrumbs='Home / Input Distribution'>
                <Row className='p-3'>
                    {mode === "1" &&
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Form>
                                        <Row>
                                            <Col sm={3} className="mb-2">
                                                <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => setState(e.target.value)}>
                                                    <option value="0"> All State </option>
                                                    {stateOpt}
                                                </Input>
                                            </Col>
                                            <Col md={3} className="mb-2">
                                                <Button className='text-white' color='primary' size="sm" onClick={get_distribution_list} block> Get Input Distribution List </Button>
                                            </Col>
                                            <Col md={3} className="mb-2">
                                                <Button className='text-white' color='primary' size="sm" onClick={download_excel_handler} block> Download Input Distribution Excel </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            <Card className='' color="primary" outline>
                                <CardHeader>Input Distribution List <small className='text-muted'> </small></CardHeader>
                                <Col sm={{ offset: 6, size: 3 }} style={{ position: 'absolute', top: '2px', right: '2px' }}>
                                    <InputGroup size="sm">
                                        <InputGroupText> <FaSearch /> </InputGroupText>
                                        <Input type="search" placeholder='Search' />
                                    </InputGroup>
                                </Col>
                                <CardBody>
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={[
                                            {
                                                name: '#',
                                                selector: row => row.sl,
                                                sortable: true,
                                                width: '80px'
                                            },

                                            {
                                                name: 'Input Distribution Date',
                                                selector: row => row.date,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Product Name',
                                                selector: row => row.product_name,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Distribution Quantity',
                                                selector: row => row.total_qty,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Attendance',
                                                selector: row => row.farmer_count,
                                                sortable: false,
                                            },
                                            {
                                                name: 'See Attendance',
                                                selector: row => row.action,
                                                sortable: false,
                                            },
                                        ]}
                                        data={tableData}
                                        highlightOnHover
                                        pagination
                                        fixedHeader
                                        progressPending={loading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    }

                </Row>

            </Page>
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
            >
                <ModalHeader toggle={() => setViewModal(!viewModal)}>
                    Farmer Details
                </ModalHeader>
                <ModalBody>
                    <DataTable
                        title=""
                        customStyles={custTableStyles}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.sl,
                                sortable: true,
                                width: '80px'
                            },
                            {
                                name: 'Farmer Code',
                                selector: row => row.farmer_code,
                                sortable: false,
                            },
                            {
                                name: 'Farmer Name',
                                selector: row => row.farmer_name,
                                sortable: false,
                                width: "50%"
                            },
                            {
                                name: 'Quantity',
                                selector: row => row.qty,
                                sortable: false
                            },
                        ]}
                        data={modalData}
                        highlightOnHover
                        pagination
                        fixedHeader
                        progressPending={loading}
                    />
                </ModalBody>
            </Modal>

            <Footer />

        </>
    )

}

export default Distribution;